import styled from "styled-components";
import { palette } from "styled-theme";

const WorkDiaryWrapper = styled.div`
  display: flex;
   flex-direction: column;
  height: calc(100vh - 140px);

  .outer{
    display:flex;
    align-items:center;
    justify-content:center;
    padding: 20px 0 0 0;
    height: 100%;
    overflow: auto;
    .inner{
      border: 1px solid ${palette("border", 0)};
      padding:10px 20px;
      width: fit-content;
       height: 100%;
      display: flex;
    }
  }
  .pdf {
    display: flex;
    overflow: auto;
    .horizontal_line {
      &.long {
        width: 450px;
      }
  }
`;

export default WorkDiaryWrapper;
